import React, { Component } from 'react'
import Link from '../utils/link'

import NewsletterForm from './newsletter'

import Logo from '../assets/images/logo.svg'
import LinkedIn from '../assets/images/linkedin-white.svg'
import Email from '../assets/images/email.svg'
import parse from 'html-react-parser'

class Header extends Component {

  state = {
    offCanvas: false,
    offCanvasServices: false,
    scrolled: false,
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollDetect)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollDetect)
  }

  onScroll = () => {
    this.setState({
      scrolled: window.scrollY > 1,
    })
  }

  scrollDetect = () => {
    window.clearTimeout( this.isScrolling )
    this.isScrolling = setTimeout(this.onScroll, 0);
  }

  _hideOffCanvas = () => {
    this.setState({ offCanvas: false })
  }

  _toggleOffCanvas = () => {
    this.setState({ offCanvas: !this.state.offCanvas })
  }

  render() {

    let { offCanvas, offCanvasServices, scrolled } = this.state
    let { servicesMenu } = this.props

    let props = {
      onClick: this._hideOffCanvas,
      activeClassName: 'active'
    }

    let headerClass = 'header'
    if (scrolled) headerClass += ' header--scrolled'

    return (
      <>
        <header className={headerClass}>
          <div className='header__inner'>
            <Link to='/' title='Site Name' className='header__logo' {...props}>
              <svg xmlns="http://www.w3.org/2000/svg" width="91" height="22" viewBox="0 0 91 22" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M10.59 21.45C12.81 21.45 14.57 20.94 15.87 19.92C17.33 18.8 18.06 17.2 18.06 15.12C18.06 13.86 17.715 12.76 17.025 11.82C16.335 10.88 15.4 10.23 14.22 9.87V9.78C16.22 9.02 17.22 7.62 17.22 5.58C17.22 3.86 16.6 2.49 15.36 1.47C14.16 0.49 12.49 0 10.35 0H0V21.45H10.59ZM9.57 8.49H5.25V4.2H9.6C10.38 4.2 11 4.39 11.46 4.77C11.92 5.15 12.15 5.67 12.15 6.33C12.15 7.01 11.915 7.54 11.445 7.92C10.975 8.3 10.35 8.49 9.57 8.49ZM9.99 17.19H5.25V12.09H9.93C10.77 12.09 11.46 12.315 12 12.765C12.54 13.215 12.81 13.85 12.81 14.67C12.81 15.43 12.555 16.04 12.045 16.5C11.535 16.96 10.85 17.19 9.99 17.19ZM24.345 3.96V0H19.455V3.96H24.345ZM24.345 21.45V6.09H19.455V21.45H24.345ZM33.84 21.93C36.28 21.93 38.25 21.16 39.75 19.62C41.27 18.08 42.03 16.14 42.03 13.8C42.03 11.46 41.275 9.52 39.765 7.98C38.255 6.44 36.28 5.67 33.84 5.67C31.4 5.67 29.42 6.44 27.9 7.98C26.38 9.52 25.62 11.46 25.62 13.8C25.62 16.14 26.38 18.08 27.9 19.62C29.42 21.16 31.4 21.93 33.84 21.93ZM33.81 18.45C32.77 18.45 31.97 18.03 31.41 17.19C30.85 16.35 30.57 15.22 30.57 13.8C30.57 12.36 30.85 11.22 31.41 10.38C31.97 9.54 32.77 9.12 33.81 9.12C34.85 9.12 35.655 9.545 36.225 10.395C36.795 11.245 37.08 12.38 37.08 13.8C37.08 15.22 36.795 16.35 36.225 17.19C35.655 18.03 34.85 18.45 33.81 18.45ZM52.395 21.45V0.72H48.375C48.135 2.06 47.525 3.08 46.545 3.78C45.565 4.48 44.355 4.85 42.915 4.89V8.31H47.325V21.45H52.395ZM63.72 21.93C66.46 21.93 68.665 20.955 70.335 19.005C72.005 17.055 72.84 14.45 72.84 11.19C72.84 7.93 72.015 5.325 70.365 3.375C68.715 1.425 66.51 0.45 63.75 0.45C61.03 0.45 58.835 1.425 57.165 3.375C55.495 5.325 54.66 7.93 54.66 11.19C54.66 14.43 55.495 17.03 57.165 18.99C58.835 20.95 61.02 21.93 63.72 21.93ZM63.75 17.97C62.43 17.97 61.45 17.37 60.81 16.17C60.17 14.97 59.85 13.31 59.85 11.19C59.85 9.07 60.17 7.405 60.81 6.195C61.45 4.985 62.43 4.38 63.75 4.38C65.07 4.38 66.045 4.99 66.675 6.21C67.305 7.43 67.62 9.09 67.62 11.19C67.62 15.71 66.33 17.97 63.75 17.97ZM83.265 21.45V0.72H79.245C79.005 2.06 78.395 3.08 77.415 3.78C76.435 4.48 75.225 4.85 73.785 4.89V8.31H78.195V21.45H83.265ZM90.9 21.45V16.41H85.77V21.45H90.9Z" fill="white"/>
              </svg>
            </Link>
            <nav className='header__nav'>
              <ul>
                <li className='header__dropdown'>
                  <button to='/services/' {...props}>Services</button>
                  <ul>
                    {servicesMenu.map((item, i) => (
                      <li key={i}><Link to={item.link.url} {...props}>{parse(item.link.title)}</Link></li>
                    ))}
                  </ul>
                </li>
                <li><Link to='/about-us' {...props}>About Us</Link></li>
                <li><Link to='/case-studies' {...props}>Case Studies</Link></li>
                <li><Link to='/people' {...props}>Team</Link></li>
                <li><Link to='/contact' {...props}>Contact Us</Link></li>
              </ul>
            </nav>
            <button onClick={this._toggleOffCanvas} className={ offCanvas ? 'header__hamburger active' : 'header__hamburger' }>
              <span className='lines'></span>
            </button>
          </div>
        </header>
        <div className={`off-canvas ${ offCanvas && 'off-canvas--active' }`}>
          <div className='off-canvas__inner'>
            <nav className='off-canvas__nav'>
              <ul>
                <li className={`off-canvas__dropdown${offCanvasServices ? ' active' : ''}`}>
                  <button to='#' onClick={() => this.setState({ offCanvasServices: !offCanvasServices })}>
                    Services
                    <span className='arrow'></span>
                  </button>
                  <ul>
                    {servicesMenu.map((item, i) => (
                      <li key={i}><Link to={item.link.url} {...props}>{parse(item.link.title)}</Link></li>
                    ))}
                  </ul>
                </li>
                <li><Link to='/about-us' {...props}>About Us</Link></li>
                <li><Link to='/case-studies' {...props}>Case Studies</Link></li>
                <li><Link to='/people' {...props}>Team</Link></li>
                <li><Link to='/contact' {...props}>Contact Us</Link></li>
              </ul>
            </nav>
            <ul className='off-canvas__social'>
              <li><Link to='https://au.linkedin.com/company/bio101'><img src={LinkedIn} alt='Bio101 - LinkedIn' /></Link></li>
              <li><Link to='mailto:info@bio101.com'><img src={Email} alt='Bio101 - Email' /></Link></li>
            </ul>
            <NewsletterForm />
            <div className='off-canvas__contact'>
              <h4><Link to='tel:+6198767890'>+61 9876 7890</Link></h4>
              <h4><Link to='mailto:info@bio101.com'>info@bio101.com</Link></h4>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Header
